import { useSideModalState } from '@twilio-paste/core/side-modal';

type Arguments = Parameters<typeof useSideModalState>;

export const useDrawer = (options: Arguments[0] = {}) => useSideModalState(options);
